import React from 'react';
import styled from 'styled-components';
import CrownIcon from '../../sites/travelerProfile/components/icons/CrownIcon';

const ButtonContainer = styled.div`
  width: ${(props) => props?.width || ""};
`;

const Button = styled.button`
  display: flex;
  width: ${(props) => props.width || "141px"};
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 3.2px;
  border: 1px solid var(--Theme-Warning, #BC8C3F);
  background: var(--Theme-Warning, #BC8C3F);

  span {
    color: var(--Gray-White, #FFF);
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 21px */
  }
`;

const PremiumAccessButton = ({ width = "141px",buttonContainerWidth = "", ...props }) => {
  const handleUpgradeClick = () => {
    window.open('https://main.viatrm.com/connects-new', '_blank');
  };

  return (
    <ButtonContainer width={buttonContainerWidth}>
      <Button type="button" width={width} onClick={handleUpgradeClick} {...props}>
        <CrownIcon width='17px' height='17px' color='white' /> <span>Upgrade</span>
      </Button>
    </ButtonContainer>
  );
};

export default PremiumAccessButton;